<template>
  <h3 class='leve2-title'><slot/></h3>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
.leve2-title{
  text-align: center;
  font-size: 30px;
  color: #000;
  padding-top: 72px;
  padding-bottom: 16px;
  position: relative;
  line-height: 1;
  
  &:after{
    position: absolute;
    width: 155px;
    height: 4px;
    background-color: #e4007f;
    content: '';
    bottom: 0;
    left:50%;
    transform: translateX(-50%);
  }
}
</style>
